export const AUTOCOMPLETE_NOPE = 'nope';
export const AUTOCOMPLETE_NEW_PASSWORD = 'new-password';

export const COUNTRIES = {
    MX: {
        name: 'México',
        id: 'MX',
        prefixMotorcredit: 'motorcredit-core-mexico/v7',
        prefixMotorcreditWithBank: 'motorcredit-core-mexico/{{bank}}/v1',
        locale: 'es-mx',
        securityClientId: 'motorcredit_for_dealer_mexico',
        totalReferences: 3,
        bureauOptionIdCreditCardLastDigits: 3,
        requiredCreditCardLastDigits: 4,
        oneSignalApp: 'ac5a8139-0379-489f-bb3e-2bb7597b05fa'
    }
};
